import { Link, type To } from "react-router-dom";
import Text from "../UI/Text";
import styles from "./AuthFooter.module.css";

interface AuthFooterProps {
  label?: string;
  linkText: string;
  to: To;
  state?: Record<string, unknown>;
  replace?: boolean;
}

export default function AuthFooter({
  label,
  linkText,
  to,
  state,
  replace,
}: AuthFooterProps) {
  return (
    <div className={styles.footer}>
      {label && <Text as="span">{label}</Text>}
      <Text as="span">
        <Link to={to} state={state} replace={replace}>
          {linkText}
        </Link>
      </Text>
    </div>
  );
}
